export default __webpack_public_path__ + "static/media/bas_01-1.2a13def0.jpg";